var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvanceSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66659 9.16602H4.66659M6.33325 12.4993H4.66659M11.3333 5.83268H4.66659M14.6666 8.74935V5.66602C14.6666 4.26588 14.6666 3.56582 14.3941 3.03104C14.1544 2.56063 13.772 2.17818 13.3016 1.9385C12.7668 1.66602 12.0667 1.66602 10.6666 1.66602H5.33325C3.93312 1.66602 3.23306 1.66602 2.69828 1.9385C2.22787 2.17818 1.84542 2.56063 1.60574 3.03104C1.33325 3.56582 1.33325 4.26588 1.33325 5.66602V14.3327C1.33325 15.7328 1.33325 16.4329 1.60574 16.9677C1.84542 17.4381 2.22787 17.8205 2.69828 18.0602C3.23306 18.3327 3.93312 18.3327 5.33325 18.3327H7.58325M16.3333 18.3327L15.0833 17.0827M15.9166 14.9993C15.9166 16.6102 14.6107 17.916 12.9999 17.916C11.3891 17.916 10.0833 16.6102 10.0833 14.9993C10.0833 13.3885 11.3891 12.0827 12.9999 12.0827C14.6107 12.0827 15.9166 13.3885 15.9166 14.9993Z",
    stroke: "#1C4E9D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvanceSearchIcon);
export default __webpack_public_path__ + "static/media/advance_search_icon.795f9d0e5e12158e003ca3cbd48c8935.svg";
export { ForwardRef as ReactComponent };